'use strict';

var device = require('./lib/device');

module.exports = function () {
  // Digits get dropped in samsung browser
  return !device.isSamsungBrowser();
};



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/~/restricted-input/supports-input-formatting.js
// module id = 845
// module chunks = 0